export default "__VITE_ASSET__BFJ1rmfR__"